module.exports = __webpack_public_path__ + "img/image-4.34ad95df.jpeg";